// extracted by mini-css-extract-plugin
export default {"host":"MenuDelimiter_host__UFKCL"};